import React from 'react';
import { InvestorStatementItem } from '../../../models/admin/InvestorStatement';
import StatementReplaceConfirmDialog from './StatementReplaceConfirmDialog';
import StatementSendEmailDialog from './StatementSendEmailDialog';
import StatementSendEmailPrompt from './StatementSendEmailPrompt';

type ToastFn = (message: string, type: 'error' | 'warning' | 'info' | 'success') => void;

interface StatementReviewOverlaysProps {
  replaceWarningItem: InvestorStatementItem | null;
  promptItem: InvestorStatementItem | null;
  composeItem: InvestorStatementItem | null;
  onCancelReplace: () => void;
  onConfirmReplace: () => void;
  onDeclineSend: () => void;
  onAcceptSend: () => void;
  onCloseCompose: () => void;
  onSent: (externalId: string) => void;
  onShowToast: ToastFn;
}

/** The three mutually-exclusive-ish overlay states of StatementReviewList's confirm/send flow. */
const StatementReviewOverlays: React.FC<StatementReviewOverlaysProps> = ({
  replaceWarningItem,
  promptItem,
  composeItem,
  onCancelReplace,
  onConfirmReplace,
  onDeclineSend,
  onAcceptSend,
  onCloseCompose,
  onSent,
  onShowToast,
}) => (
  <>
    {replaceWarningItem && (
      <StatementReplaceConfirmDialog
        item={replaceWarningItem}
        onCancel={onCancelReplace}
        onConfirm={onConfirmReplace}
      />
    )}
    {promptItem && (
      <StatementSendEmailPrompt
        item={promptItem}
        onDecline={onDeclineSend}
        onAccept={onAcceptSend}
      />
    )}
    {composeItem && (
      <StatementSendEmailDialog
        item={composeItem}
        onClose={onCloseCompose}
        onSent={() => onSent(composeItem.externalId)}
        onShowToast={onShowToast}
      />
    )}
  </>
);

export default StatementReviewOverlays;
